module.exports = __webpack_public_path__ + "img/joinDialog-bg.1e86f564.png";